const REPORTS_LIST_CACHE_TTL = 5 * 60 * 1000;
const REPORT_ACCESS_CACHE_TTL = 5 * 60 * 1000;

const getCachedSessionData = (key, ttl) => {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;

    if (parsed.expiresAt && parsed.expiresAt <= Date.now()) {
      sessionStorage.removeItem(key);
      return null;
    }

    return parsed.data;
  } catch (error) {
    return null;
  }
};

const setCachedSessionData = (key, data, ttl) => {
  try {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        data,
        expiresAt: Date.now() + ttl,
      }),
    );
  } catch (error) {
    // Ignore storage failures gracefully.
  }
};

const clearSessionCacheByPrefix = (prefix) => {
  try {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch (error) {
    // Ignore storage failures gracefully.
  }
};

const getCachedUserReports = (userId) =>
  getCachedSessionData(
    `onedata:prefetched-reports:${userId}`,
    REPORTS_LIST_CACHE_TTL,
  );

const setCachedUserReports = (userId, data) =>
  setCachedSessionData(
    `onedata:prefetched-reports:${userId}`,
    data,
    REPORTS_LIST_CACHE_TTL,
  );

const clearUserReportCache = (userId) => {
  if (userId) {
    sessionStorage.removeItem(`onedata:prefetched-reports:${userId}`);
    return;
  }

  clearSessionCacheByPrefix('onedata:prefetched-reports:');
};

const clearReportAccessCache = () => {
  clearSessionCacheByPrefix('onedata:report-access:');
};

export {
  clearReportAccessCache,
  clearSessionCacheByPrefix,
  clearUserReportCache,
  getCachedSessionData,
  getCachedUserReports,
  REPORT_ACCESS_CACHE_TTL,
  REPORTS_LIST_CACHE_TTL,
  setCachedSessionData,
  setCachedUserReports,
};
